<div class="container-fluid py-1">
<div class="d-flex flex-row mt-5 ms-3">
    <div class="col">
        <div class="content-header d-flex justify-content-between">
            <div class="d-flex flex-row align-items-center">
                <fa-icon *ngIf='faCloud' [icon]='faCloud' class="align-self-center"></fa-icon>
                <p class="ms-2 title">{{title}}</p>
            </div>
        </div>
        <p class="content-header title" style="margin-left: 30px;">{{nextHeader}}</p>
    </div>
</div>

<div class="d-flex flex-row mt-3" *ngIf="!checkIfPlanNonHosted()">
    <div >
    <a class="btn wizard-button underline ">Buy NCache </a>
  </div>
  <div >
    <a class="btn wizard-button ">Create Quotation </a>
  </div>
  <div >
    <a class="btn wizard-button ">Preview Quotation </a>
  </div>
</div>
<div class="col-md-6 p-3">

    <p>
        You can purchase NCache Quotation <span *ngIf="!this.isSupportPlan"> either by choosing
        <strong *ngIf="!checkIfPlanNonHosted()">Create Quotation</strong> <strong *ngIf="checkIfPlanNonHosted()">Request Quotation</strong> or</span> with a <strong>Enter Quotation</strong> provided
        to you on email by our Sales Team.
    </p>
        <div>
            <div class="form-check" id="selfbuydiv" *ngIf="!this.isSupportPlan">
                <input class="form-check-input" type="radio" id="selfbuy" name="buyOptionRadio" [value]="PurchasePath.CreateQuotation"
                    [(ngModel)]="purchasePath" (change)="updateOnBuyNCacheSelection()" [formControl]="this.buyOptionRadioSelfBuy"/>
                <label for="selfbuy" class="form-check-label">
                    <strong *ngIf="!checkIfPlanNonHosted()">Create Quotation</strong> <strong *ngIf="checkIfPlanNonHosted()">Request Quotation</strong>
                </label>
                <footer *ngIf="!checkIfPlanNonHosted()" class="text-muted" id="radiobuttonhints" >
                    Quickly purchase NCache quotation based on your requirements
                </footer>
                <footer *ngIf="checkIfPlanNonHosted()" class="text-muted" id="radiobuttonhints">
                    This will send an email to <a href="mailto:sales&#64;alachisoft.com">sales&#64;alachisoft.com</a> to generate a quotation for you.
                </footer>                
            </div>
            <div class="form-check" id="customkeydiv">
                <input class="form-check-input" type="radio" id="customqoute" name="buyOptionRadio"
                    [value]="PurchasePath.AlreadyCreated" [(ngModel)]="purchasePath"
                    (change)="updateOnBuyNCacheSelection()" [formControl]="this.buyOptionRadioAcceptInvoice"/>

                <label for="customqoute" class="form-check-label">
                    <strong>Enter Quotation </strong>
                </label>
                <footer class="text-muted">
                    I Already have a Custom Quotation for NCache
                </footer>
            </div>
        </div>

        <div class="container" id="keyentryinput">
            <label for="InvoiceID">Quotation ID <span class="text-danger">*</span></label>
            <input id="InvoiceID" type="text" name="InvoiceID" class="form-control form-control-sm"
                placeholder="00000000-0000-0000-0000-000000000000" [formControl]="this.quotationId"
                [pattern]="guidMatchingPattern"/>
        </div>

    <p id="supporttext">
        Please contact us at
        <span class="text-primary">
            <a href="mailto:sales&#64;alachisoft.com">sales&#64;alachisoft.com</a>
        </span>
        to do capacity planning and obtain Custom Invoice.
    </p>
</div>
</div>
<div class='footer bg-light' dir="ltr" fxLayoutGap="25px">

    <button
    class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
    [disabled]="true"
    >
      Previous
  </button>

    <button
    class="btn btn-nc me-3 btn-sm submit btn-primary btn-width"
    [disabled]="canProceedToPricing()"
    (click)="onNext()"
    >
  Next
  </button>
  <button
    class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
   (click)="cancel()"
  >
  Cancel
  </button>
</div>
